import React from "react";

import Icon from "antd/lib/icon";

import { ReactComponent as BackIconSVG } from "../../styles/images/icons/back.svg";

const BackIcon = () => <Icon component={BackIconSVG} />;

export default BackIcon;
